import { trackEvent } from '../../analytics';
import { zIndex } from '../../components/styled';
import { AnalyticsEvents } from '../../constants/analytics';
import useRetryUntilResolved from '../../hooks/useRetryUntilResolved';

const ZendeskWidgetScript = () => {
  useRetryUntilResolved(() => {
    if (!window.zE) {
      return false;
    }
    window.zESettings = {
      webWidget: {
        zIndex: zIndex.CHAT_WIDGET,
        chat: {
          connectOnPageLoad: false
        }
      }
    };

    // @ts-expect-error no zendesk types
    window.zE('webWidget:on', 'open', function () {
      // @ts-expect-error no zendesk types
      window.zE('webWidget', 'updateSettings', { webWidget: { zIndex: zIndex.CHAT_WIDGET_OPEN } });
      void trackEvent(AnalyticsEvents.CHAT_WIDGET_OPEN);
    });

    // @ts-expect-error no zendesk types
    window.zE('webWidget:on', 'close', function () {
      // @ts-expect-error no zendesk types
      window.zE('webWidget', 'updateSettings', { webWidget: { zIndex: zIndex.CHAT_WIDGET } });
      void trackEvent(AnalyticsEvents.CHAT_WIDGET_CLOSE);
    });

    return true;
  });

  return (
    <script
      id="ze-snippet"
      src="https://static.zdassets.com/ekr/snippet.js?key=303b756f-0798-4486-8221-8d70a93d9f98"
      async
      defer
    />
  );
};

export default ZendeskWidgetScript;
